export default class CommonError extends Error {
  myStack: string | undefined;

  constructor(message?: string, name?: string) {
    super();
    this.name = name || 'Common error';
    this.message = message || '[CustomError] Error';
    this.myStack = this.stack;
    this.stack = undefined;
  }
}
